import styled from "styled-components";

export const ToolTipContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
`;

export const ToolTipText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin-right: 7px;
`;
